import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectConfig } from '../../redux/slices/configSlice';
import { sendRichMessage } from '../../utils/sendRichMessage';

const isValidDate = (day, month, year) => {
  const date = new Date(`${year}-${month}-${day}`);
  return (
    date.getDate() === parseInt(day) &&
    date.getMonth() + 1 === parseInt(month) &&
    date.getFullYear() === parseInt(year)
  );
};

const isInFuture = (day, month, year) => {
  const inputDate = new Date(`${year}-${month}-${day}`);
  const today = new Date();
  return inputDate > today;
};

const isTooOld = (year) => {
  return year < 1900;
};

const DOBInputSeparate = () => {
  const config = useSelector(selectConfig);
  const RmConfigs = config?.data?.[0]?.attributes.RichMediaConfigs;
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const reduxState = useSelector(state => state);
  const monthRef = useRef(null);
  const yearRef = useRef(null);

  console.log(RmConfigs);

  const handleDayChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 2) {
      setDay(value);
      if (value.length === 2) {
        monthRef.current?.focus();
      }
    }
    setError('');
  };

  const handleMonthChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 2) {
      setMonth(value);
      if (value.length === 2) {
        yearRef.current?.focus();
      }
    }
    setError('');
  };

  const handleYearChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 4) setYear(value);
    setError('');
  };

  const validateDOB = () => {
    if (!day || !month || !year) { // RichmediaDOBIncompleteFieldErrorMessage
      setError(RmConfigs.RichmediaDOBIncompleteFieldErrorMessage);
      return false;
    }

    if (parseInt(day) < 1 || parseInt(day) > 31) { // RichmediaDOBDayErrorMessage
      setError(RmConfigs.RichmediaDOBDayErrorMessage);
      return false;
    }

    if (parseInt(month) < 1 || parseInt(month) > 12) { // RichmediaDOBMonthErrorMessage
      setError(RmConfigs.RichmediaDOBMonthErrorMessage);
      return false;
    }

    if (year.length !== 4) { // RichmediaDOBYearErrorMessage
      setError(RmConfigs.RichmediaDOBYearErrorMessage);
      return false;
    }

    if (!isValidDate(day, month, year)) { // RichmediaDOBInvalidDateErrorMessage
      setError(RmConfigs.RichmediaDOBInvalidDateErrorMessage);
      return false;
    }

    if (isInFuture(day, month, year)) { // RichmediaDOBFutureErrorMessage
      setError(RmConfigs.RichmediaDOBFutureErrorMessage);
      return false;
    }

    if (isTooOld(parseInt(year))) { // RichmediaDOBOldErrorMessage
      setError(RmConfigs.RichmediaDOBOldErrorMessage);
      return false;
    }

    // ✅ Add 18-year-old validation
    const birthDate = new Date(year, month - 1, day); // JS months are 0-indexed
    const today = new Date();
    const ageDiff = today.getFullYear() - birthDate.getFullYear();
    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
  
    const age = hasHadBirthdayThisYear ? ageDiff : ageDiff - 1;
  
    if (age < 18) { // RichmediaDOBAgeErrorMessage
      setError(RmConfigs.RichmediaDOBAgeErrorMessage);
      return false;
    }

    setError('');
    return true;
  };

  const handleBlur = () => {
    if (day && month && year) validateDOB();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateDOB()) {
      const dob = `${month}/${day}/${year}`;
      sendRichMessage(dob, reduxState);
      setSubmitted(true); // disable button after successful submission
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: 'flex',
        flexFlow: 'column',
        width: 'auto',
        textAlign: 'left',
        background: '#e5e5ea',
        padding: '12px',
        borderRadius: '12px',
        margin: '12px 12px 0 30px'
      }}
    >
      <div>
        <input
          type="text"
          inputMode="numeric"
          pattern="\d*"
          placeholder={RmConfigs.RichmediaDOBDayPlaceholder}
          value={day}
          onChange={handleDayChange}
          onBlur={handleBlur}
          maxLength={2}
          style={{ width: '50px', padding: '6px' }}
          disabled={submitted}
        />
        <input
          type="text"
          inputMode="numeric"
          pattern="\d*"
          placeholder={RmConfigs.RichmediaDOBMonthPlaceholder}
          value={month}
          onChange={handleMonthChange}
          onBlur={handleBlur}
          maxLength={2}
          ref={monthRef}
          style={{ width: '50px', padding: '6px' }}
          disabled={submitted}
        />
        <input
          type="text"
          inputMode="numeric"
          pattern="\d*"
          placeholder={RmConfigs.RichmediaDOBYearPlaceholder}
          value={year}
          onChange={handleYearChange}
          onBlur={handleBlur}
          maxLength={4}
          ref={yearRef}
          style={{ width: '80px', padding: '6px' }}
          disabled={submitted}
        />
      </div>
      <button
        type="submit"
        disabled={submitted}
        className='dafabet'
        style={{
          borderColor: "transparent",
          borderRadius: "14px",
          padding: "0.4rem 2rem",
          margin: "0.5rem 0",
          backgroundColor: submitted ? "lightgray" : "#af0000",
          color: submitted ? "darkgray" : "#fff",
          textTransform: "capitalize",
          cursor: submitted ? "not-allowed" : "pointer",
        }}
      >
      提交
      </button>
      {error && <div style={{ color: 'red', marginTop: '5px' }}>{error}</div>}
    </form>
  );
};

export default DOBInputSeparate;
